import { useSelector } from 'react-redux';
import { SharedStoreState } from 'types';

export const selectUserSettings = (state: SharedStoreState) =>
	state.userSettings;
export const useSelectUserSettings = () => useSelector(selectUserSettings);
